import '@babel/polyfill';
import Vue from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';
import API from './API.js';
import App from './App.vue';
import './plugins/highcharts.js';
import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import router from './router';
import store from './store/store.js';

Vue.prototype.$http = API;
window.$http = API;

Vue.use(DatetimePicker);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
